export function truncateUserId(id: string): string {
  if (id.length <= 8) {
    return id;
  }
  return `${id.slice(0, 4)}…${id.slice(-4)}`;
}

const COMPACT_ZONE: Record<string, string> = {
  PDT: 'PT',
  PST: 'PT',
  MDT: 'MT',
  MST: 'MT',
  CDT: 'CT',
  CST: 'CT',
  EDT: 'ET',
  EST: 'ET',
  AKDT: 'AKT',
  AKST: 'AKT',
  HDT: 'HT',
  HST: 'HT',
};

export function compactTimeZoneName(name: string): string {
  if (!name) {
    return '';
  }
  if (COMPACT_ZONE[name]) {
    return COMPACT_ZONE[name];
  }
  if (/^[A-Z]{2,4}[DS]T$/.test(name)) {
    return name.replace(/[DS]T$/, 'T');
  }
  return name;
}

function part(
  parts: Intl.DateTimeFormatPart[],
  type: Intl.DateTimeFormatPartTypes,
): string {
  return parts.find((item) => item.type === type)?.value ?? '';
}

export function formatHostDateTime(value: string | Date): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  const parts = new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).formatToParts(date);
  const month = part(parts, 'month');
  const day = part(parts, 'day');
  const hour = part(parts, 'hour');
  const minute = part(parts, 'minute');
  const dayPeriod = part(parts, 'dayPeriod');
  const zone = compactTimeZoneName(part(parts, 'timeZoneName'));
  const time = [
    hour,
    minute ? `:${minute}` : '',
    dayPeriod ? ` ${dayPeriod}` : '',
  ]
    .join('')
    .trim();
  return `${month} ${day}, ${time} ${zone}`.replace(/\s+/g, ' ').trim();
}

export function formatHostDate(value: string | Date): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  });
}
